import {Pipe} from "@angular/core";
/**
 * Created by nijin on 19/2/17.
 */
@Pipe({
  name: 'prettyprint'
})
export class PrettyPrintPipe {
  transform(val) {
    return JSON.stringify(val, null, 2)
      .replace(/ /g, '&nbsp;')
      .replace(/\n/g, '<br/>');
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/shared/jsonformater.pipe.ts